// extracted by mini-css-extract-plugin
export default {"banner":"AccountOverviewView_banner__vAgpl","bannerSpace":"AccountOverviewView_bannerSpace__T2tND"};